<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <WdsPageSignup class="wds-page-signup-login" nav-prev @prev="back">
    <template #left>
      <LeftWelcome />
    </template>

    <template #nav-right>
      <AuthLanguageSwitcher />
    </template>

    <template #right>
      <WdsHeading as="h1" type="title1">
        {{ $t('Reset your password') }}
      </WdsHeading>

      <WdsText large secondary>
        {{
          $t("Forgot your password? Don't worry, we will send you reset instructions to your email")
        }}
      </WdsText>

      <WdsAlert v-if="status !== ''">
        {{ status }}
      </WdsAlert>

      <BaseHtmlForm action="/forgot-password" method="POST" class="tw-mt-8">
        <WdsInput
          v-model="email"
          name="email"
          type="email"
          :placeholder="$t('example@company.com')"
          autofocus
          required
          lg
          :error="errorsList.length === 0 ? undefined : errorsList.join('\n')"
          data-test="forgot-password-email-input"
          @input="clearErrors"
        >
          <template #label>
            {{ $t('Email') }}
          </template>
        </WdsInput>

        <div class="tw-text-center tw-mt-6">
          <WdsButton primary full-width lg data-test="forgot-password-reset-password-button">
            {{ $t('Reset password') }}
          </WdsButton>
        </div>
      </BaseHtmlForm>
    </template>
  </WdsPageSignup>
</template>

<script lang="ts">
import { PropType, Ref, ref } from 'vue'
import {
  WdsAlert,
  WdsButton,
  WdsHeading,
  WdsInput,
  WdsPageSignup,
  WdsText,
} from '@worksome/wds-components'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'
import AuthLanguageSwitcher from '@/components/auth/AuthLanguageSwitcher.vue'
import LeftWelcome from '@/components/auth/left/LeftWelcome.vue'
import { $t } from '@/composables/translation'

export default {
  name: 'ForgotPasswordPage',
  components: {
    BaseHtmlForm,
    AuthLanguageSwitcher,
    LeftWelcome,
    WdsButton,
    WdsHeading,
    WdsInput,
    WdsPageSignup,
    WdsText,
    WdsAlert,
  },
  props: {
    errors: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    status: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const errorsList: Ref<string[]> = ref([])
    const errorStatus: Ref<string | null> = ref(null)

    errorsList.value = props.errors
    errorStatus.value = props.status

    function back() {
      window.location.href = `${window.location.protocol}//${window.location.host}/login`
    }

    function clearErrors() {
      errorsList.value = []
      errorStatus.value = ''
    }

    return {
      back,
      clearErrors,
      errorsList,
      errorStatus,
      $t,
    }
  },
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
      email: '',
    }
  },
}
</script>

<style scoped></style>
